import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../../../utils/utils';

@Component({
    selector: 'osh-createwavepopup',
    templateUrl: './createwavepopup.component.html',
    styleUrls: ['./createwavepopup.component.less'],
    standalone: false
})
export class OshCreateWavePopupComponent implements OnInit {
    form!: FormGroup
    constructor(
        public dialogRef: MatDialogRef<OshCreateWavePopupComponent>,
        private readonly formBuilder: FormBuilder,
        private readonly http: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly toastrService: ToastrService) { }

    ngOnInit(): void {
        const startDateRaw = this.data?.startDate ?? this.data?.StartDate;
        const startDateValue = startDateRaw ? new Date(startDateRaw) : null;

        const endDateRaw = this.data?.endDate ?? this.data?.EndDate;
        const endDateValue = endDateRaw ? new Date(endDateRaw) : null;

        this.form = this.formBuilder.group({
            waveId: [this.data?.waveId ?? this.data?.id ?? this.data?.WaveId ?? this.data?.Id],
            name: [this.data?.name ?? this.data?.Name, Validators.required],
            description: [this.data?.description ?? this.data?.Description],
            startDate: [startDateValue, Validators.required],
            endDate: [endDateValue, Validators.required],
        });
    }
    
    onSubmit() {
        if (this.form)
            if (this.form.invalid) {
                return;
            }

        if (this.form.value?.waveId) {
            Utils.httpUpdateOshWave(
                this.http
                , this.baseUrl
                , this.form.value
                , this
                , function (tthis: OshCreateWavePopupComponent, result: any) {
                    tthis.dialogRef.close({ event: 'submit' });
                    if (result) {
                        tthis.toastrService.success('Wave was updated successfully!');
                    }
                    else
                        tthis.toastrService.error('Wave could not be updated. Please, contact with administrator');
                },
                null
            );
        } else {
            // Create new wave
            Utils.httpCreateOshWave(
                this.http
                , this.baseUrl
                , this.form.value
                , this
                , function (tthis: OshCreateWavePopupComponent, result: any) {
                    tthis.dialogRef.close({ event: 'submit' });
                    if (result) {
                        tthis.toastrService.success('Wave was created successfully!');
                    }
                    else
                        tthis.toastrService.error('Wave could not be created. Please, contact with administrator');
                },
                null
            );
        }
    }

    onDateChange(event: any, controlName: string) {
        const utcDate = Utils.dateUTCchange(event);
        this.form.get(controlName)?.setValue(utcDate);
    }

    backButtonHandler(event: any) {
        event.preventDefault();
        this.dialogRef.close();
    }
}

